import { isContentfulLink, isGatsbyEntryRef, UnknownRecord } from './shared'

type OverlayFields = (
  node: UnknownRecord,
  fields: UnknownRecord,
  fieldsById: Map<string, UnknownRecord>,
) => UnknownRecord

/**
 * Same linked entry: the walk already overlays its fields by contentful_id. A different link target
 * only swaps scalars we understand onto the existing Gatsby shape — we never invent or reorder
 * section/card arrays here (that waits for save re-source).
 */
export const overlayEntryLink = (
  value: unknown,
  field: unknown,
  fieldsById: Map<string, UnknownRecord>,
  overlayFields: OverlayFields,
): unknown | undefined => {
  if (!isContentfulLink(field, 'Entry') || !isGatsbyEntryRef(value)) return undefined
  if (field.sys.id === value.contentful_id) return undefined

  const linkedFields = fieldsById.get(field.sys.id)
  if (!linkedFields) return undefined

  return {
    ...value,
    contentful_id: field.sys.id,
    ...overlayFields(value, linkedFields, fieldsById),
  }
}
